@let widget =
  widgetsEc.plugins.currentEntityPlugin.feature.selectors
    .getLatestEntity()
    .asSignal();
@let preview =
  this.widgetPreviewPlugin.feature.selectors.currentWidgetPreview.asSignal();
@let error =
  widgetPreviewPlugin.feature.selectors.currentWidgetPreviewError.asSignal();
@let isLoading =
  widgetPreviewPlugin.feature.selectors.currentWidgetPreviewIsLoading.asSignal();
@let schema = schemaFeature.selectors.schema.asSignal();

<div class="atn-widget-builder-query-tab">
  <div class="atn-widget-builder-query-tab__query-editor">
    <atn-ds-code
      label="Query"
      syntax="dms-query"
      [json]="widget?.query"
      [syntaxSelector]="true"
      [schema]="schema"
      (jsonChange)="updateWidgetQuery($event)"
      (execute)="runQuery('QueryEditor.ExecuteAction.Ran')"
    />
  </div>
  <div class="atn-widget-builder-query-tab__preview">
    <i
      class="atn-icon atn-run atn-blue atn-widget-builder-query-tab__run-query"
      (click)="runQuery('RunButton.Clicked')"
    ></i>
    <atn-ds-floating-horizontal-tabs>
      <ng-template
        atnDsTab
        name="Design view"
      >
        @if (!isLoading) {
          <atn-mosaic-widget
            [rendering]="preview"
            [refId]="widgetRefIdForPreview"
            [error]="error?.message"
          />
        } @else {
          <atn-ds-loader />
        }
      </ng-template>
      <ng-template
        atnDsTab
        name="JSON view"
      >
        @if (!isLoading) {
          <atn-ds-code
            syntax="mosaic-widget-rendering"
            [value]="preview ? (preview | json) : error?.message"
          />
        } @else {
          <atn-ds-loader />
        }
      </ng-template>
    </atn-ds-floating-horizontal-tabs>
  </div>
</div>
